module.exports = __webpack_public_path__ + "static/media/poster.bfc5ade0.webp";